import { motion } from "framer-motion";
import { Lock } from "lucide-react";

export default function Placeholder({ title, icon: Icon, description }) {
  return (
    <div className="h-full p-4 lg:p-5">
      <div className="jv-panel h-full flex flex-col items-center justify-center text-center relative overflow-hidden">
        <div className="pointer-events-none absolute inset-0 jv-grid-lines opacity-40" />
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-jarvis-cyan/40 to-transparent jv-scanline" />

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className="relative z-10 flex flex-col items-center"
        >
          <div className="relative w-24 h-24 flex items-center justify-center mb-6">
            <span className="absolute inset-0 rounded-full border border-jarvis-cyan/30 jv-pulse text-jarvis-cyan" />
            <span className="absolute inset-3 rounded-full border border-jarvis-cyan/20" />
            {Icon && <Icon className="w-9 h-9 text-jarvis-cyan drop-shadow-[0_0_12px_rgba(0,240,255,0.5)]" />}
          </div>

          <h1 className="font-mono text-2xl lg:text-3xl uppercase tracking-[0.3em] font-bold text-jarvis-cyan jv-glow mb-3">
            {title}
          </h1>
          <p className="max-w-md text-sm text-slate-400 leading-relaxed mb-6">{description}</p>

          <div className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] px-4 py-2 rounded-md border border-jarvis-amber/30 bg-jarvis-amber/5 text-jarvis-amber">
            <Lock className="w-3.5 h-3.5" />
            Module Initializing
          </div>
        </motion.div>
      </div>
    </div>
  );
}
